module.exports = __webpack_public_path__ + "img/98.bb4f0565.webp";